import { useQuery } from '@tanstack/react-query';
import { getRoles } from 'src/api/getRoles/getRoles';

export const useRoles = () => {
  const { data: rolesData, isLoading } = useQuery({
    queryKey: ['roles'],
    queryFn: getRoles,
    cacheTime: Infinity,
  });
  const roles = rolesData?.data?.sort((a, b) => a.name.localeCompare(b.name)) || [];

  return { roles, isLoading };
};
